import { Controller } from '@hotwired/stimulus'

// Enseña solo los grupos de campos que corresponden al valor de un <select>. Lo usa el
// formulario de tarifa de luz: cada tipo (fija, discriminación horaria, indexada) tiene sus
// propios precios de energía, y pedir los de los otros tipos solo invita a equivocarse.
//
// Los grupos ocultos además se deshabilitan: sus valores no se envían y el navegador no exige
// sus campos `required`. El modelo borra igualmente al guardar los precios que no son del tipo
// (TarifaLuz). Sin JS se verían todos los grupos y el navegador pediría los obligatorios de los
// tres tipos; no se cubre porque el panel ya depende de JS (autocompletado de la comercializadora).
//
// Targets:
//   - selector: el <select> del tipo
//   - grupo: cada bloque de campos, con data-tipo igual a la opción del select que lo muestra
export default class extends Controller {
  static targets = ['selector', 'grupo']

  connect () {
    this.actualizar()
  }

  actualizar () {
    if (!this.hasSelectorTarget) return

    this.grupoTargets.forEach(grupo => {
      const visible = grupo.dataset.tipo === this.selectorTarget.value

      grupo.hidden = !visible
      grupo.querySelectorAll('input, select, textarea').forEach(campo => { campo.disabled = !visible })
    })
  }
}
